export default __webpack_public_path__ + "static/media/logo_KCSiT.c9deb5b8.svg";